import React from 'react';
import styles from '../styles.module.css';
// import ImageGallery from './ImageGallery/index.tsx';
import { productCardType, ProductImage, shopServiceType } from '@/commonTypes';
import ImageGallery from './ImageGallery';

export default function Gallery({
  data,
  className = '',
}: {
  data?: productCardType | shopServiceType;
  className?: string;
}) {
  const list = [
    { id: 1, name: '/imgs/logo.svg' },
    { id: 2, name: '/imgs/shop/imageIcon.svg' },
    { id: 3, name: '/imgs/sampleImage.jpg' },
    { id: 4, name: '/imgs/sampleImage2.avif' },
    { id: 5, name: '/imgs/logo.svg' },
    { id: 6, name: '/imgs/logo.svg' },
  ];
  const galleryImages: ProductImage[] =
    data?.gallery?.images?.files?.map((d) => ({
      id: d.id,
      name: d.name,
    })) ?? [];
  return (
    <div className={`${styles.gallery} ${className}`}>
      <ImageGallery
        // images={data?.image ? [data.image].concat(galleryImages) : galleryImages}
        images={list}
        data={data}
      />
    </div>
  );
}
